export default __webpack_public_path__ + "static/media/ic_health.bd43c9cf.svg";